// Copyright (c) 2016 Deere & Company

import DeliveryNoDocuments from '@deere/cps-it.warranty-model-factory/lib/delivery-no-documents';
import t from 'tcomb';

const Report = t.list(DeliveryNoDocuments, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/state/report.js